module.exports = __webpack_public_path__ + "img/icon-check.1fe23ca9.png";